import '../show/bootstrap_lpc_js';
import '../show/helpers/mobile';
import './helpers/gr_integration_tracking';
import { ShowThankYouPageLogger } from './helpers/logger';
import customCodeModifier from '../show/modifiers/custom_code';
import countdownTimerCodeModifier from '../show/modifiers/countdown_timer';
import grBadge from '../show/modifiers/gr_badge';
import { LPSThankYouData } from './models/config';
import { ModuleLoader } from '../../modules/ModuleLoader';
import { Badge } from '../show/modifiers/badge';

ShowThankYouPageLogger.log('Initializing Thank-You-Page Show');

window.addEventListener('load', async () => {
  customCodeModifier.enableScripts();
  countdownTimerCodeModifier.enableScripts();

  try {
    Badge.init();
    await grBadge.initialize();
  } catch (e) {
    ShowThankYouPageLogger.error(e);
  }

  if (LPSThankYouData.isGrChatEnabled()) {
    ModuleLoader.loadGrChat({
      grChatUrlParams: LPSThankYouData.getGrChatUrlParams(),
      logger: ShowThankYouPageLogger,
      isMAX: LPSThankYouData.isMAX(),
    });
  }
});
